export default __webpack_public_path__ + "static/media/DynamicSLR70.92470d32.jpg";